var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrioridade(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6C4 5.44772 4.44772 5 5 5H28C28.3844 5 28.7348 5.22035 28.9013 5.56681C29.0678 5.91328 29.021 6.32453 28.7809 6.6247L23.2806 13.5L28.7809 20.3753C29.021 20.6755 29.0678 21.0867 28.9013 21.4332C28.7348 21.7797 28.3844 22 28 22H6V27C6 27.5523 5.55228 28 5 28C4.44772 28 4 27.5523 4 27V6ZM6 20H25.9194L21.2191 14.1247C20.927 13.7595 20.927 13.2405 21.2191 12.8753L25.9194 7H6V20Z",
    fill: "#232840"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrioridade);
export default __webpack_public_path__ + "static/media/prioridade.50928471c6b9aeba2c2ce913fe082aee.svg";
export { ForwardRef as ReactComponent };